module.exports = __webpack_public_path__ + "static/media/slider_bg_1.ff3a7eef.jpg";